import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './TrialBanner.css';

export default function TrialBanner() {
  const { user, isTrialExpired, daysRemaining } = useAuth();
  
  if (!user || !user.trial_end_date) return null;

  const isWarning = daysRemaining <= 5 && daysRemaining >= 0;

  if (isTrialExpired) {
    return (
      <div className="trial-banner expired">
        <div className="trial-banner-content">
          <span className="trial-icon">⚠️</span>
          <span className="trial-text">
            Your trial has expired. <strong>Please renew your subscription</strong> to continue using the system.
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className={`trial-banner ${isWarning ? 'warning' : 'active'}`}>
      <div className="trial-banner-content">
        <span className="trial-icon">{isWarning ? '⏳' : '📅'}</span>
        <span className="trial-text">
          Your free trial ends in <strong>{daysRemaining} day{daysRemaining !== 1 ? 's' : ''}</strong>
        </span>
      </div>
    </div>
  );
}
